/* Calvielle preview-only catalogue controls. Product data and server sorting stay native. */
if (!customElements.get('calvielle-bracelets')) {
  customElements.define('calvielle-bracelets', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.grid = this.querySelector('[data-product-grid]');
      this.cards = [...this.querySelectorAll('[data-product-card]')];
      this.filters = this.querySelector('[data-style-filters]');
      this.complete = this.cards.length > 0 && this.cards.length === Number(this.dataset.total);
      this.count = this.querySelector('[data-result-count]');
      this.empty = this.querySelector('[data-filter-empty]');
      this.form = this.querySelector('[data-sort-form]');
      this.select = this.querySelector('[data-sort-select]');

      // Never filter a partial page. Beyond 250 pieces Liquid retains native pagination.
      if (this.filters && this.complete) {
        if (this.dataset.sort === 'manual') {
          this.cards.sort((a, b) => Number(a.dataset.group) - Number(b.dataset.group));
          this.grid.append(...this.cards);
        }
        this.filters.querySelectorAll('[data-style]').forEach(button => {
          const style = button.dataset.style;
          button.hidden = style !== 'all' && !this.cards.some(card => this.matchesStyle(card, style));
          button.addEventListener('click', () => this.applyStyle(style, true), options);
        });
        this.querySelector('[data-style-reset]')?.addEventListener('click', () => {
          this.applyStyle('all', true);
          this.filters.querySelector('[data-style="all"]')?.focus();
        }, options);
        this.filters.hidden = false;
        this.applyStyle(new URL(location.href).searchParams.get('cv_style') || 'all', false);
        window.addEventListener('popstate', () => {
          this.applyStyle(new URL(location.href).searchParams.get('cv_style') || 'all', false);
        }, options);
      }

      if (this.form && this.select) {
        this.syncForm();
        this.form.addEventListener('submit', () => this.syncForm(), options);
        this.select.addEventListener('change', () => this.form.requestSubmit(), options);
        this.form.dataset.enhanced = 'true';
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    matchesStyle(card, style) {
      return style === 'all' || (card.dataset.style || '').split(' ').includes(style);
    }

    applyStyle(requestedStyle, updateUrl) {
      if (!this.complete || !this.filters) return;
      const allowed = [...this.filters.querySelectorAll('[data-style]')].filter(button => !button.hidden);
      const style = allowed.some(button => button.dataset.style === requestedStyle) ? requestedStyle : 'all';
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = !this.matchesStyle(card, style);
        if (!card.hidden) count++;
      });
      allowed.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.style === style)));
      if (this.count) this.count.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
      if (this.empty) this.empty.hidden = count !== 0;
      // Retired or unavailable selections resolve to All, including older saved links.
      if (updateUrl || requestedStyle !== style) {
        const url = new URL(location.href);
        if (updateUrl) url.searchParams.delete('page');
        if (style === 'all') url.searchParams.delete('cv_style');
        else url.searchParams.set('cv_style', style);
        history.replaceState(history.state, '', url);
      }
      this.syncForm();
    }

    syncForm() {
      if (!this.form) return;
      this.form.querySelectorAll('[data-retained-param]').forEach(input => input.remove());
      // Preserve market, query and draft preview context while restarting server pagination.
      for (const [name, value] of new URL(location.href).searchParams) {
        if (name === 'sort_by' || name === 'page') continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.dataset.retainedParam = '';
        this.form.append(input);
      }
    }
  });
}
